import axios from 'axios';

export default class FilterService
{
    public static async getList(viewId: string)
    {
        return (await axios.get<Pagination<Resource<FiltersFormModel>>>('admin/filters', {
            params: {
                viewId: viewId
            }
        })).data;
    }

    public static async save(params: FiltersFormModel)
    {
        return (await axios.post<Resource<FiltersFormModel>>('admin/filters', params)).data;
    }

    public static async update(id: number, params: FiltersFormModel)
    {
        return (await axios.put<Statement>(`admin/filters/${id}`, params)).data;
    }

    public static async delete(id: number)
    {
        return (await axios.delete<Statement>(`admin/filters/${id}`)).data;
    }
}

export interface FiltersFormModel
{
    id?: number;
    name?: string;
    viewId?: string;
    filterType?: 'Global' | 'Private';
    contentJson?: string;
}

export interface FilterContent
{
    visible: string[];
    form: any;
}

export interface FilterState extends FilterContent
{
    activeTemplate: FiltersFormModel;
}

export const instanceOfFilterContent = (object: any): object is FilterContent =>
{
    return object && typeof object === 'object' && 'visible' in object && 'form' in object;
};

export function parseContent(contentJson: string): FilterContent
{
    let content = convertDates(JSON.parse(contentJson || '{}'));

    if (!instanceOfFilterContent(content))
    {
        content = {
            visible: [],
            form: content
        };
    }

    return content;
}
